export default __webpack_public_path__ + "f1e8c27032b9b0e0ec7edada130a09d7.png";